import { render, staticRenderFns } from "./regiscompany.vue?vue&type=template&id=f233d65a"
import script from "./regiscompany.vue?vue&type=script&lang=js"
export * from "./regiscompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports